import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
const formatCrewComplement = (value) => {
    return Number.isFinite(value) ? value.toFixed(1) : String(value);
};
export const UnderAverageCrewComplementTable = ({ options }) => {
    const [isFetching, setIsFetching] = useState(false);
    const [hasResult, setHasResult] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [vessels, setVessels] = useState([]);
    useEffect(() => {
        if (!options.isReady) {
            setIsFetching(false);
            setHasResult(false);
            setErrorMessage("");
            setVessels([]);
            return;
        }
        setIsFetching(true);
        setHasResult(false);
        setErrorMessage("");
        const params = new URLSearchParams();
        params.append("year", String(options.year));
        params.append("quarter", String(options.quarter));
        options.fleetIds.forEach((id) => params.append("fleetIds", String(id)));
        fetch(`/api/insights/workload/underaveragecrewcomplement?${params}`)
            .then((res) => {
            if (res.status === 204)
                return null;
            if (res.ok)
                return res.json();
            throw new Error(res.statusText);
        })
            .then((data) => {
            if (data === null) {
                setVessels([]);
                setHasResult(true);
                return;
            }
            setVessels(Array.isArray(data) ? data : []);
            setHasResult(true);
        })
            .catch((error) => {
            console.error(error);
            setErrorMessage("Error fetching under-average crew complement vessels");
        })
            .finally(() => setIsFetching(false));
    }, [options.isReady, options.year, options.quarter, options.fleetIds]);
    const isLoading = !options.isReady || isFetching;
    return (_jsxs("div", { className: "card shadow h-100", children: [_jsx("h3", { className: "card-header", children: "Vessels below industry crew complement" }), _jsxs("div", { className: "card-body", children: [_jsx("p", { className: "text-muted small mb-2", children: "Top 5 vessels with the lowest crew complement average for the selected quarter, compared against industry average for vessel type." }), isLoading && (_jsxs("div", { className: "text-center py-4", children: [_jsx("span", { className: "spinner-grow spinner-grow-sm", role: "status", "aria-hidden": "true" }), " Loading..."] })), options.isReady && errorMessage && (_jsx("div", { className: "alert alert-danger", role: "alert", children: errorMessage })), hasResult && !isLoading && vessels.length > 0 && (_jsx("div", { className: "table-responsive", children: _jsxs("table", { className: "table table-sm align-middle mb-0", children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: "Vessel" }), _jsx("th", { children: "Type" }), _jsx("th", { className: "text-end", children: "Crew Avg" }), _jsx("th", { className: "text-end", children: "Industry Avg" })] }) }), _jsx("tbody", { children: vessels.map((vessel) => (_jsxs("tr", { children: [_jsxs("td", { children: [_jsx("div", { children: vessel.VesselName }), vessel.IMO && _jsxs("div", { className: "small text-muted", children: ["IMO ", vessel.IMO] })] }), _jsx("td", { children: vessel.VesselTypeName }), _jsx("td", { className: "text-end", children: formatCrewComplement(vessel.CrewComplement) }), _jsx("td", { className: "text-end", children: vessel.CrewComplementIndustryAverage })] }, `${vessel.VesselName}-${vessel.IMO}`))) })] }) })), hasResult && !isLoading && vessels.length === 0 && !errorMessage && (_jsx("p", { className: "text-muted mb-0", children: "No vessels are below the industry crew complement benchmark." }))] })] }));
};
